module.exports = __webpack_public_path__ + "img/icon4.5f057729.png";